import React from 'react';

const viArrowUp = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    style={{
      width: '1em',
      height: '1em',
      overflow: 'visible',
    }}
  >
    <g fill="none" fillRule="evenodd">
      <path fill="currentColor" d="M7 15l5-5 5 5z" />
    </g>
  </svg>
);

export default viArrowUp;
